import { replaceDomainToLocation } from '@spot-fe/utils';
import { triggerOneLink } from '../appsflyer';
import { isApp, isPC } from '../utils';
import { loadJsHecateScript } from './jsBridge';

// app内部跳转到app
export const jumpApp = async (params) => {
  if (isApp()) {
    await loadJsHecateScript();
    window.BybitHecate?.module('Router')
      .method('push')
      .invoke(params)
      .catch(({ message }) => {
        console.error(message);
      });
  }
};

export const openBrowser = (url) =>  {
  window.BybitHecate?.module('UrlLauncher')
    .method('open')
    .invoke({ url });
}

export const h5Jump = (path, originUrl = false) => {
  if (isApp()) {
    // app内
    if (path.startsWith('bybitapp://')) {
      // bybitapp协议,直接打开
      jumpApp({ path });
    } else if (path.startsWith('by-mini://')) {
      // by-mini地址,使用bybitapp协议包裹打开
      jumpApp({
        path: `bybitapp://open/route?targetUrl=${encodeURIComponent(path)}`,
      });
    } else {
      // http地址,使用webview打开, 如果通过 webview 打开，自己拼接 `bybitapp://open/web?url=${path}`
      openBrowser(path)
    }
  } else {
    // app外,尝试唤起app,否则下载
    triggerOneLink(path);
  }
};


export const uniJump = (webUrl: string, appUrl: string) => {
  if (isPC()) {
    pcJump(webUrl);
    return;
  }
  jumpApp({
    path: appUrl,
  });
};

export const uniTryJump = (webUrl: string, appUrl: string) => {
  if (isPC()) {
    pcJump(webUrl);
    return;
  }
  h5Jump(appUrl);
};

export const pcJump = (path, newTab = true) => {
  let url = path;
  if (url.includes('bybit')) {
    url = replaceDomainToLocation(path);
  }
  const aEl = document.createElement('a');
  aEl.setAttribute('target', newTab ? '_blank' : '_self');
  aEl.setAttribute('href', url);
  document.body.appendChild(aEl);
  aEl.click();
  document.body.removeChild(aEl);
};
